import React from 'react';
import { THEME_COLORS, useTheme } from '../context/ThemeContext';

export default function ColorPicker() {
  const { bgColor, setBgColor } = useTheme();

  return (
    <div>
      <p className="text-xs text-white/50 font-bold uppercase tracking-wider mb-3">Background Color</p>
      <div className="flex flex-wrap gap-3">
        {THEME_COLORS.map((color) => (
          <button
            type="button"
            key={color.value}
            onClick={() => setBgColor(color.value)}
            className={`w-10 h-10 rounded-full border-2 transition-all ${
              bgColor === color.value ? 'border-white scale-110' : 'border-white/20 hover:border-white/40'
            }`}
            style={{ backgroundColor: color.value }}
            title={color.name}
          />
        ))}
      </div>
    </div>
  );
}
